import type { MaterialV1 } from '@ilteducation/content-registry-types';
import createContentStore from '../use-content-store';
import { apiGetPreviewUrl } from '../api/material-api';

const useMaterialsStore = () => {
  const contentStore = createContentStore<MaterialV1>('Material')();

  const { getById, getContentDownloadUrl } = contentStore;

  return {
    getById,
    getContentDownloadUrl,
    getPreviewUrl: apiGetPreviewUrl,
  };
};

export default useMaterialsStore;
